module.exports = __webpack_public_path__ + "static/media/bike-triumph.5b58f4f9.png";